// extracted by mini-css-extract-plugin
export default {"form":"LabForm_form__Iypq2","button":"LabForm_button__iGqTZ","formGroup":"LabForm_formGroup__GULa6","textEditor":"LabForm_textEditor__DhuBB"};